import { render, staticRenderFns } from "./TheFooterSocialList.vue?vue&type=template&id=4e8dedb4&scoped=true"
import script from "./TheFooterSocialList.vue?vue&type=script&lang=js"
export * from "./TheFooterSocialList.vue?vue&type=script&lang=js"
import style0 from "./TheFooterSocialList.vue?vue&type=style&index=0&id=4e8dedb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8dedb4",
  null
  
)

export default component.exports